import { render, staticRenderFns } from "./EventOutcomeSingleSelect.vue?vue&type=template&id=bf3834ec"
import script from "./EventOutcomeSingleSelect.vue?vue&type=script&lang=ts"
export * from "./EventOutcomeSingleSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports